import axios from "../../apiFc24";
import { SaveOrShareSquadRequestData } from "./save-squad";

export const shareSquad = async (data: SaveOrShareSquadRequestData) => {
  const res = await axios.post("/shared-squads", data);
  return res.data;
};
